
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalLow as ObiBatteryHorizontalLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-low.js';
 
 
 

 
 export const ObiBatteryHorizontalLow = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-low',
   elementClass: ObiBatteryHorizontalLowElement,
   events: {
     
   }
  });
 
 